<template>
  <div>
    Stores
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>